import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';
import { getPagePoint as getPagePointOfElement } from './misc-utils';
import { subtractPoints } from './point-utils';

export function isLeftButton(event: MouseEvent) {
  return event.button === 0;
}

export function isRightButton(event: MouseEvent) {
  return event.button === 2;
}

export function getRelativePoint(event: MouseEvent, element: HTMLElement) {
  return subtractPoints(getPagePoint(event), getPagePointOfElement(element));
}

export function getPagePoint(event: MouseEvent) {
  return [event.pageX, event.pageY] as Point2D;
}
